import { render, staticRenderFns } from "./ocr_view.vue?vue&type=template&id=5fa7b1d2&scoped=true"
import script from "./ocr_view.vue?vue&type=script&lang=js"
export * from "./ocr_view.vue?vue&type=script&lang=js"
import style0 from "./ocr_view.vue?vue&type=style&index=0&id=5fa7b1d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa7b1d2",
  null
  
)

export default component.exports